import { createRouter, createWebHistory } from 'vue-router';
import financeRoutes from '@/router/financeRouter';
import calculatorRoutes from '@/router/calculatorRouter';

const routes = [
  ...financeRoutes,
  ...calculatorRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
